import Box from '@mui/material/Box';
import type { CSSProperties } from 'react';

interface Props {
  size?: number;
  color?: string;
  style?: CSSProperties;
  variant?: string;
}

export default function DashboardSvgIcon({ size = 20, color = 'currentColor', style }: Props) {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        color,
        '& svg': {
          width: '100%',
          height: '100%',
          display: 'block'
        }
      }}
      style={style}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
        <defs>
          <clipPath clipPathUnits="userSpaceOnUse" id="dashboardClipPath">
            <path d="M 0,24 H 24 V 0 H 0 Z" />
          </clipPath>
        </defs>

        <g transform="matrix(1.3333333,0,0,-1.3333333,0,32)">
          <g clipPath="url(#dashboardClipPath)">
            <g transform="translate(20,15)">
              <path
                d="m 0,0 c 0,4.725 -4.097,8.494 -8.932,7.947 -3.596,-0.406 -6.544,-3.306 -7.001,-6.896 -0.347,-2.726 0.68,-5.224 2.482,-6.902 1.494,-1.389 2.451,-3.258 2.451,-5.298 v -0.161 c 0,-1.485 1.204,-2.69 2.69,-2.69 h 0.62 c 1.486,0 1.205 2.69 2.69 v 0.549 c 0,1.845 0.885,3.533 2.272,4.75 C -1.056,-4.546 0,-2.397 0,0 Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>

            <g transform="translate(9,5)">
              <path d="M 0,0 H 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </g>

            <g transform="translate(12,5)">
              <path d="M 0,0 V 9" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </g>

            <g transform="translate(14,16)">
              <path
                d="m 0,0 c 0,-1.104 -0.896,-2 -2,-2 -1.104,0 -2,0.896 -2,2"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </g>
        </g>
      </svg>
    </Box>
  );
}
